import type { JSX } from 'react';
import { TabsContent } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { DialogFooter } from '@/components/ui/dialog';
import { CandidateSelector } from './CandidateSelector';
import type { SelectableCandidate } from '../../hooks/useCandidateFilter';

interface ExistingCandidateTabProps {
  candidates: SelectableCandidate[];
  isCandidatesLoading: boolean;
  selectedCandidateId: string | null;
  onSelect: (id: string | null) => void;
  linkedCandidateIds: string[];
  onLink: () => void;
  onCancel: () => void;
  isAdding: boolean;
}

export function ExistingCandidateTab({
  candidates,
  isCandidatesLoading,
  selectedCandidateId,
  onSelect,
  linkedCandidateIds,
  onLink,
  onCancel,
  isAdding,
}: ExistingCandidateTabProps): JSX.Element {
  return (
    <TabsContent value="existing" className="space-y-4 mt-4">
      <div className="space-y-2">
        <Label>Select Candidate</Label>
        <CandidateSelector
          candidates={candidates}
          selectedCandidateId={selectedCandidateId}
          onSelect={onSelect}
          excludeIds={linkedCandidateIds}
          isLoading={isCandidatesLoading}
          placeholder="Search for a candidate..."
        />
        <p className="text-xs text-muted-foreground">Candidates already linked are excluded.</p>
      </div>
      <DialogFooter>
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={onLink} disabled={isAdding || !selectedCandidateId}>
          {isAdding ? 'Linking...' : 'Link Candidate'}
        </Button>
      </DialogFooter>
    </TabsContent>
  );
}
